import { render, staticRenderFns } from "./reviewResult.vue?vue&type=template&id=d04782b0&scoped=true&"
import script from "./reviewResult.vue?vue&type=script&lang=js&"
export * from "./reviewResult.vue?vue&type=script&lang=js&"
import style0 from "./reviewResult.vue?vue&type=style&index=0&id=d04782b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d04782b0",
  null
  
)

export default component.exports